import * as types from '../actions/actionTypes';

export default function stockCustomReducer(state: any = {}, action: any) {
    switch (action.type) {
        case types.STOCK_CUSTOM_SET:
            return { ...state, ...action.stockCustom };
        default:
            return state;
    }
}